var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonArrow',{staticClass:"login-button",attrs:{"data-toggle":"modal","data-target":"#loginModal"}},[_vm._v(" Log in to your account ")])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/reused-components/login-button/LoginButton.vue